const MODULE = 'OTHER_FEE_QUANTITY_MATRIX'
export const GET_QUANTITY_MATRIX_CALCULATION_LIST = `${MODULE}/get_quantity_matrix_calculation_list`;
export const QUANTITY_MATRIX_CALCULATION_INFO = `${MODULE}/quantity_matrix_calculation_info`;
export const CREATE_QUANTITY_MATRIX_FEES = `${MODULE}/create_quantity_matrix_fees`;
export const UPDATE_QUANTITY_MATRIX_FEES = `${MODULE}/update_quantity_matrix_fees`;
export const GET_NEW_OTHER_FEES = 'NEW_OTHER_FEES/get_new_other_fees';
export const GET_SINGLE_NEW_OTHER_FEES =
  'NEW_OTHER_FEES/get_single_new_other_fees';

export const FORM_DATA = {
  multiplier: '',
  amount: '',
  unit: '',
  capacity: ''
};


